import { useState } from 'react';
import { cn } from '../../lib/utils';
import { transCls } from '../../const/ui';
import { getDepthPadding } from './build-tree';
import { EntryItem } from './entry-item';
import type { EntryTreeItem, BsEntrySelectChangeResult } from './types';
import { SolidArrowDownIcon } from '../bs-icons';

const ChevronRightIcon = ({ size }: { size?: number }) => (
  <SolidArrowDownIcon className="-rotate-90" size={size} />
);

export function TreeItemNode({
  item,
  selectedEntryId,
  appId,
  section,
  onSelect,
}: {
  item: EntryTreeItem;
  selectedEntryId: string | undefined;
  appId: string;
  section: 'current' | 'other';
  onSelect: (result: BsEntrySelectChangeResult) => void;
}) {
  const [expanded, setExpanded] = useState(true);

  if (item.type === 'group') {
    return (
      <div>
        <div
          className={cn(
            'flex items-center gap-[6px] h-[34px] px-[10px] cursor-pointer rounded-[4px]',
            getDepthPadding(item.depth),
            'hover:bg-[#EFF0F6]',
            transCls,
          )}
          onClick={() => setExpanded(!expanded)}
        >
          <span
            className={cn(
              'shrink-0 flex items-center justify-center w-[16px] h-[16px]',
              transCls,
              expanded && 'rotate-90',
            )}
          >
            <ChevronRightIcon size={16} />
          </span>
          <i
            className="icon-bsy-folder-close"
            style={{ fontSize: 16, lineHeight: 1 }}
          />
          <span className="text-[14px] text-[#030303] truncate">
            {item.name}
          </span>
        </div>
        {expanded &&
          item.children.map((child) => (
            <TreeItemNode
              key={child.id}
              item={child}
              selectedEntryId={selectedEntryId}
              appId={appId}
              section={section}
              onSelect={onSelect}
            />
          ))}
      </div>
    );
  }

  return (
    <EntryItem
      item={item}
      depth={item.depth}
      isSelected={selectedEntryId === item.id}
      onClick={() => {
        if (item.entry) {
          onSelect({ entry: item.entry, appId, section });
        }
      }}
    />
  );
}
